import { fetchData } from "@axios/axios-client";

import type { AdminUserDetailApiResponse, BranchAdminListItem } from "./types";

function unwrapAdminUserDetailPayload(res: unknown): unknown {
  if (res == null || typeof res !== "object") return null;
  if (
    "user" in res &&
    (res as { user: unknown }).user != null &&
    typeof (res as { user: unknown }).user === "object"
  ) {
    return (res as { user: unknown }).user;
  }
  return res;
}

function asAdminUserDetail(
  payload: unknown,
): AdminUserDetailApiResponse | null {
  if (payload == null || typeof payload !== "object") return null;
  const o = payload as Record<string, unknown>;
  if (typeof o.id !== "string") return null;
  return payload as AdminUserDetailApiResponse;
}

function asAdminListResponse(res: unknown): BranchAdminListItem[] {
  return Array.isArray(res) ? (res as BranchAdminListItem[]) : [];
}

export const getBranchAdminsApi = async (
  branchId: string,
): Promise<BranchAdminListItem[]> => {
  if (!branchId) return [];
  const res = await fetchData({}, `/branches/${branchId}/admin-users`, "GET");
  return asAdminListResponse(res);
};

export const getAdminByIdApi = async (
  adminId: string,
): Promise<AdminUserDetailApiResponse | null> => {
  if (!adminId) return null;
  const raw = await fetchData({}, `/admin-users/${adminId}`, "GET");
  return asAdminUserDetail(unwrapAdminUserDetailPayload(raw));
};

export const softDeleteAdminsApi = async (id: string) => {
  return fetchData({}, `/admin-users/${id}`, "DELETE");
};
export const bulkDeleteAdminsApi = async (ids: string[]) => {
  return fetchData({ ids }, `/admin-users`, "PATCH");
};

export const inviteAdminApi = async ({ data }: { data: unknown }) => {
  await fetchData(data as object, `/admin-users`, "POST");
};

export const updateAdminApi = async ({
  data,
  id,
}: {
  data: unknown;
  id?: string;
}) => {
  await fetchData(data as object, `/admin-users/${id}`, "PATCH");
};

export const forgetPasswordAdminApi = async (email: string) => {
  return fetchData({ email }, `/auth/admins/forgot-password`, "POST");
};
